import http from "@/api/request";
import { AGENT_BUSINESS_BASE } from "@/config/apiBaseUrlConfig";

import type {
  BusinessEntityCreateRequest,
  BusinessEntityDetailVO,
  BusinessEntityPageQueryRequest,
  BusinessEntityPreviewRequest,
  BusinessEntityResyncRequest,
  BusinessEntityUpdateRequest,
  PageDataBusinessEntityPageItemVO,
} from "./type";

/**
 * 分页查询工商实体
 * GET /service-chijing-agent/api/business/getPage
 * @param params 分页与筛选条件
 */
export const getBusinessEntityPage = (params: BusinessEntityPageQueryRequest) => {
  return http.get<PageDataBusinessEntityPageItemVO>(`${AGENT_BUSINESS_BASE}/getPage`, {
    params,
  });
};

/**
 * 信用代码预查并保存
 * POST /service-chijing-agent/api/business/preview
 * @param data 信用代码与同步渠道
 */
export const previewBusinessEntity = (data: BusinessEntityPreviewRequest) => {
  return http.post<BusinessEntityDetailVO>(`${AGENT_BUSINESS_BASE}/preview`, data);
};

/**
 * 新增工商实体（信用代码拉取创建，或已落库实体绑定用户）
 * POST /service-chijing-agent/api/business/addEntity
 * @param data 信用代码 / 已保存实体 ID 与可选绑定用户
 */
export const addBusinessEntity = (data: BusinessEntityCreateRequest) => {
  return http.post<number>(`${AGENT_BUSINESS_BASE}/addEntity`, data);
};

/**
 * 查询工商实体详情（返回工商 API 同步字段及本地证照 / 关联信息）
 * GET /service-chijing-agent/api/business/getEntity/{id}
 * @param id 工商实体 ID
 */
export const getBusinessEntityDetail = (id: string) => {
  return http.get<BusinessEntityDetailVO>(`${AGENT_BUSINESS_BASE}/getEntity/${id}`);
};

/**
 * 刷新工商数据（重新同步第三方工商数据）
 * PUT /service-chijing-agent/api/business/resyncEntity/{id}
 * @param id 工商实体 ID
 * @param data 同步渠道，默认沿用上次或 mock
 */
export const resyncBusinessEntity = (id: string, data?: BusinessEntityResyncRequest) => {
  return http.put<BusinessEntityDetailVO>(`${AGENT_BUSINESS_BASE}/resyncEntity/${id}`, data ?? {});
};

/**
 * 编辑工商实体（仅允许更新 licenseFileUrl）
 * PUT /service-chijing-agent/api/business/updateEntity/{id}
 * @param id 工商实体 ID
 * @param data 证照 URL，传 null 清除
 */
export const updateBusinessEntity = (id: string, data: BusinessEntityUpdateRequest) => {
  return http.put<BusinessEntityDetailVO>(`${AGENT_BUSINESS_BASE}/updateEntity/${id}`, data);
};
